import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-caption mb-1 text-info" };
const _hoisted_2 = {
    key: 0,
    class: "skeleton-box rounded-xl",
    style: { "height": "20px" }
};
const _hoisted_3 = {
    key: 1,
    class: "text-body-1"
};
import { computed } from 'vue';
import BN from 'bignumber.js';
import { formatUsdValue } from '@/core/helper/number-format-helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddressTokenFiatInfo',
    props: {
        loading: { type: Boolean },
        fiatValue: null,
        text: null
    },
    setup(__props) {
        const props = __props;
        /**
         * Returns formatted FIAT value
         */
        const valueFiatFormatted = computed(() => {
            if (!props.loading) {
                const format = new BN(props.fiatValue || 0);
                return formatUsdValue(format).value;
            }
            return '$0.00';
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            return (_openBlock(), _createBlock(_component_v_col, {
                cols: "6",
                md: "4",
                lg: "3",
                class: "mt-4"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.text), 1),
                    (props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(valueFiatFormatted)), 1))
                ]),
                _: 1
            }));
        };
    }
});
